<template>
  <div class="talk">
    <!-- <div class="talk-box" :class="type == 'nolive' ? 'notype' : ''">说点什么呗...</div> -->
    <div class="talk-box" :class="{'notype':type == 'nolive','send_wrap':text}">
      <van-field class="input_focus" v-model="text" center clearable @keyup.enter.native="inputImport" placeholder="Leave a message..." placeholder-class="input_place" maxlength="100" @focus='inputFocus' type="text" ref="barInput" size="small">
      </van-field>
    </div>
    <div class="send_btn" @click="inputImport" v-if="text">
      Send
    </div>
    <div class="talk-iconbox" v-else>
      <div class="icon1" style="user-select:none;/*用户是否能够选中文本*/" @touchstart="changanStart" @touchend="changanEnd" @click="zsClick" v-if="type == 'live'">
        <img style="pointer-events:none;" src="https://img.zhanshangxiu.com/showonline/file/202006/3a133b0b4dc74bf2974aa360046bf1a7.png" />
      </div>
      <div class="icon1" @click="$emit('sendHandle', 'zan')" v-if="type == 'nolive'" :class="islike ? 'icon-active' : ''">
        <i class="icon iconfont icon-dianzanxuanzhong"></i>
      </div>
      <div class="icon1" @click="$emit('sendHandle', 'lang')" v-if="type == 'live'" :class="isShowSubTitle?'icon-active':''">
        <i class="icon iconfont icon-zimu-b"></i>
      </div>
      <div class="icon1" @click="$emit('sendHandle', 'collect')" :class="isLove ? 'icon-active' : ''">
        <i class="icon iconfont icon-guanzhu-xian" v-if="!isLove"></i>
        <i class="icon iconfont icon-love" v-if="isLove"></i>
      </div>
      <div class="icon1" @click="$emit('sendHandle', 'share')">
        <i class="icon iconfont icon-fenxiang2"></i>
      </div>
      <div class="icon1" @click="$emit('sendHandle', 'close')">
        <i class="icon iconfont icon-guanbi2"></i>
      </div>
      <liveDianzan></liveDianzan>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import liveDianzan from "./live-dianzan-canvas";
export default {
  name: "talk",
  props: ["type", "islike", "isLove", "isShowSubTitle"],
  data() {
    return {
      timer: null,
      timerOut: null,
      text: "", //文本
    };
  },
  components: {
    liveDianzan,
  },
  created() {
    console.log(this.type, "类型");
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    query() {
      return this.$router.history.current.query;
    },
    roomId() {
      return this.query.actId;
    },
  },
  methods: {
    ...mapActions({
      likeTo: "likeTo", //直播点赞
    }),
    inputImport(str) {
      this.send();
    },
    //发送事件点击
    send() {
      if (!this.userInfo.email) {
        this.$Myapollo.unverifiedDialog(this, true);
        return;
      }
      // if (/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.text)) {
      //   this.$toast.fail("请勿发送手机号！");
      //   // this.text = "";
      //   return;
      // }
      if (this.text == "") return;
      this.$nextTick(() => {
        this.$refs.barInput.blur();
      });
      this.isFocus = false;
      this.$emit("watchliveSend", this.text);
      this.text = "";
    },
    //长按开始
    changanStart() {
      this.timerOut = setTimeout(() => {
        this.timer = setInterval(() => {
          this.zsGoto();
        }, 100);
      }, 500);
    },
    zsClick() {
      this.zsGoto();
    },
    //长按结束
    changanEnd() {
      clearTimeout(this.timerOut);
      clearInterval(this.timer);
      this.timerOut = null;
      this.timer = null;
    },
    //掌声点击
    async zsGoto() {
      if (!this.roomId) {
        wx.showToast({
          title: "error",
          icon: "none",
        });
        return;
      }
      let opt = {
        roomId: this.roomId,
        number: 1,
        showAnimation: true,
      };
      await this.likeTo(opt);
      if (window.navigator.vibrate) {
        // console.log('支持')
        window.navigator.vibrate(200);
      }
    },
    //input获焦
    inputFocus() {
      if (!this.userInfo) {
        this.$refs.barInput.blur();
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      if (!this.userInfo.email) {
        this.$refs.barInput.blur();
        this.$Myapollo.unverifiedDialog(this, true);
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.talk {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 49px;
  line-height: 49px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 0 15px;
  align-items: center;
  &-box {
    width: 120px;
    height: 32px;
    background-color: #f2f2f2;
    border-radius: 16px;
    padding: 0 14px;
    margin-right: 25px;
    font-size: 11px;
    color: #666;
    display: flex;
    align-items: center;
  }
  .notype {
    width: 49%;
    &.send_wrap {
      width: 80%;
      margin-right: 10px;
    }
  }
  .send_wrap {
    width: 80%;
    margin-right: 10px;
  }
  .send_btn {
    height: 32px;
    background: #1890ff;
    padding: 0 0.3rem;
    color: #fff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  &-iconbox {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .icon1 {
      width: 32px;
      height: 32px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: #f3f3f3;
      img {
        max-width: 100%;
        max-width: 100%;
      }
      .iconfont {
        font-size: 28px;
        color: #666;
      }
      .icon-dianzanxuanzhong {
        font-size: 24px;
        color: #999;
      }
    }
    .icon-active {
      color: #ff5d00;
      background: rgba(255, 94, 0, 0.1);
      .icon {
        color: #ff5d00;
      }
    }
  }
}
.input_focus {
  height: 100%;
  border: none;
  background: #f2f2f2;
  padding: 0.1rem 0;
  color: #000;
}
</style>